export default {
    props: {
        field: String,
        title: String,
        template: String | Function,
        headerTemplate: String | Function,
        width: String | Number
    }
}



// WEBPACK FOOTER //
// ./packages/kendo-dropdowns-vue-wrapper/src/KendoMultiColumnComboBox/Columns.js